import script from "./NotificationsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsPopup.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsPopup.vue?vue&type=style&index=0&id=7140e988&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7140e988"]])

export default __exports__